import { AnimatePresence, motion } from "framer-motion";

export default function Loader({ show }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050505]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          data-testid="app-loader"
        >
          <div className="relative h-16 w-16">
            <div className="absolute inset-0 rounded-full border-2 border-white/10" />
            <div className="loader-ring absolute inset-0 rounded-full border-2 border-transparent border-t-blue-500" />
          </div>
          <motion.div
            className="mt-6 font-display text-2xl font-semibold tracking-tight"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
          >
            JOBL<span className="text-blue-500">SX</span>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
